import { useState } from "react";
import Reveal from "@/components/feature/Reveal";

export default function DownloadSection() {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section id="download" className="bg-background-50">
      <div className="mx-auto w-full max-w-page px-4 py-12 md:px-8 md:py-16">
        <div className="overflow-hidden rounded-lg border border-background-200 bg-accent-50/70">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <Reveal className="order-2 p-6 md:p-10 lg:order-1 lg:p-12">
              <span className="inline-flex items-center gap-2 rounded-full border border-accent-200 bg-background-50 px-3.5 py-1.5 text-xs text-accent-800">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-download-2-line text-base" />
                </span>
                手机端体验更顺
              </span>

              <h2 className="mt-5 font-heading text-2xl font-semibold leading-snug text-foreground-950 md:text-[30px]">
                下载黑料六点 App
                <br />
                六点一到，先响一声
              </h2>

              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                傍晚新料、晚间吃瓜、当事人回应和网友评论都会推到手机上。
                下班路上打开就是最新的，不用来回翻。
              </p>

              <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
                <a
                  href="#download"
                  className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:text-base"
                >
                  <span className="flex h-5 w-5 items-center justify-center">
                    <i className="ri-smartphone-line text-lg" />
                  </span>
                  扫码或点此下载
                </a>
                <button
                  type="button"
                  onClick={handleCopy}
                  className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 md:text-base"
                >
                  <span className="flex h-5 w-5 items-center justify-center">
                    <i className={copied ? "ri-check-line text-lg" : "ri-link text-lg"} />
                  </span>
                  {copied ? "下载链接已复制" : "复制下载链接"}
                </button>
              </div>

              <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-checkbox-circle-line text-sm text-secondary-600" />
                  整点更新提醒
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-checkbox-circle-line text-sm text-secondary-600" />
                  只推真·新料
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-checkbox-circle-line text-sm text-secondary-600" />
                  评论区随时围观
                </span>
              </div>
            </Reveal>

            <Reveal className="order-1 h-56 w-full lg:order-2 lg:h-auto" delay={80}>
              <div className="h-full w-full">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20a%20warm%20evening%20window%20glow%20with%20abstract%20silhouette%20skyline%20and%20a%20simple%20phone%20shape%2C%20amber%20and%20terracotta%20limited%20palette%2C%20minimal%20editorial%20vector%20art%2C%20clean%20soft%20cream%20background%2C%20no%20text%2C%20no%20people&width=1000&height=900&seq=heyl-6pm-download&orientation=squarish"
                  alt="黑料六点 App 傍晚使用场景插画"
                  title="黑料六点 App 下载 晚间吃瓜"
                  className="h-full w-full object-cover object-top"
                />
              </div>
            </Reveal>
          </div>
        </div>

        <Reveal delay={120}>
          <div className="mt-6 flex flex-col gap-4 rounded-lg border border-background-200 bg-background-100/70 p-6 md:flex-row md:items-center md:justify-between md:p-8">
            <div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 md:text-xl">
                手里有料？直接丢过来
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                今晚现场照片、前后对比截图、当事人原话都欢迎。留下联系方式和线索概要，值班编辑会逐个看。
              </p>
            </div>
            <div className="flex w-full flex-col gap-3 sm:flex-row md:w-auto">
              <label className="flex items-center gap-2 rounded-full border border-background-300 bg-background-50 px-4 py-2.5">
                <span className="flex h-4 w-4 items-center justify-center text-foreground-500">
                  <i className="ri-mail-line text-base" />
                </span>
                <input
                  type="text"
                  name="contact"
                  placeholder="联系方式（选填）"
                  className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none sm:w-40"
                />
              </label>
              <button
                type="button"
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-foreground-900 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-send-plane-2-line text-base" />
                </span>
                投稿入口
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}